import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 16 16"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M9.952 4.914a.667.667 0 0 0-1.238-.495l-2.667 6.667a.667.667 0 0 0 1.238.495l2.667-6.667Zm-5.536-.768c.287.23.334.65.104.937L2.186 8l2.334 2.917a.667.667 0 0 1-1.041.833L.812 8.416a.667.667 0 0 1 0-.832L3.48 4.25a.667.667 0 0 1 .937-.104Zm7.167 0a.667.667 0 0 0-.104.937L13.812 8l-2.333 2.917a.667.667 0 0 0 1.04.833l2.668-3.334a.667.667 0 0 0 0-.832L12.52 4.25a.667.667 0 0 0-.937-.104Z",
      clipRule: "evenodd"
    }
  )
);
var SvgContextualRoutingOutlined = styled(SvgComponent)`
  ${size}
  ${color}
`;
var ContextualRoutingOutlined_default = SvgContextualRoutingOutlined;

export { ContextualRoutingOutlined_default as default };
